export default import.meta.ROLLUP_FILE_URL_dc8630b5;